// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"logo-module--imageContainer--3SMFA","brand":"logo-module--brand--2iOlW","brandOverlay":"logo-module--brandOverlay--ykVOQ","landing":"logo-module--landing--6f3dx"};